import WhatsApp from "./icons/WhatsApp";
import { trackOutboundClick } from "../utils/analytics";

const WHATSAPP_URL =
    "https://api.whatsapp.com/send/?phone=917046216489&text=Hello%2C+I+want+to+discuss+my+project+with+Abox+Agency&type=phone_number&app_absent=0";

export default function WhatsAppButton() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whats-app-button"
            onClick={() => trackOutboundClick("whatsapp_float_button", WHATSAPP_URL)}
        >
            <div className="d-flex flex-column align-items-center">
                <WhatsApp className="whats-app-icon" />
                <div className="under-line"></div>
                <p className="button-content">Chat with us</p>
            </div>
            <img src='/assets/image/badge.webp' alt="" className="bg-fade" loading="lazy" />
            {/* <video width={"100%"} className="bg-fade" autoPlay loop muted playsInline>
                <source src="/assets/image/bg-fade.mp4" type="video/mp4" />
            </video> */}
        </a>
    )
}